<template>
  <div>
    <my-notification :icon="'info'">
      <template #title>
        {{ $t('compTransitionDocsWhyWrapper.title-1') }}
      </template>
      <span v-html="$t('compTransitionDocsWhyWrapper.info-1')" />
      <p style="margin-top: 8px"></p>
    </my-notification>
    <br />
    <br />
    <h3 style="text-align: center; font-size: 1.1em">
      <b>
        {{ $t('compTransitionDocsWhyWrapper.title-2') }}
        <em>Transition 1point5</em> ?</b
      >
    </h3>
    <div class="columns" style="margin: 25px 10px">
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #d14d65">
            <span class="title is-6" style="color: #fff">{{
              $t('compTransitionDocsWhyWrapper.info-9')
            }}</span>
          </div>
          <div
            class="column col-content col-content-1"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-area-chart" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compTransitionDocsWhyWrapper.info-10')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #8a4869">
            <span class="title is-6" style="color: #fff">{{
              $t('compTransitionDocsWhyWrapper.info-11')
            }}</span>
          </div>
          <div
            class="column col-content col-content-2"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-exchange" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compTransitionDocsWhyWrapper.info-12')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #5f548d">
            <span class="title is-6" style="color: #fff">{{
              $t('compTransitionDocsWhyWrapper.info-13')
            }}</span>
          </div>
          <div
            class="column col-content col-content-3"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-tags" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compTransitionDocsWhyWrapper.info-14')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #3b589f">
            <span class="title is-6" style="color: #fff">{{
              $t('compTransitionDocsWhyWrapper.info-15')
            }}</span>
          </div>
          <div
            class="column col-content col-content-4"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-toggle-on" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compTransitionDocsWhyWrapper.info-16')"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns col-border-shaddow">
          <div class="column col-rotate" style="background-color: #0d7eb6">
            <span class="title is-6" style="color: #fff">{{
              $t('compTransitionDocsWhyWrapper.info-17')
            }}</span>
          </div>
          <div
            class="column col-content col-content-5"
            @click="displayWhy = true"
          >
            <figure class="image is-40x40">
              <i class="fa fa-puzzle-piece" style="font-size: 40px"></i>
            </figure>
            <div v-html="$t('compTransitionDocsWhyWrapper.info-18')"></div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <!-- The modal hidden between the fresk -->
    <b-modal :active.sync="displayWhy" has-modal-card :width="1000">
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compTransitionDocsWhyWrapper.why-title') }}
          </p>
        </header>
        <section class="modal-card-body">
          <why-transition-1point5 />
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'why-transition-1point5': () =>
      import('@/components/transition/docs/Why.vue')
  },
  data () {
    return {
      displayWhy: false
    }
  }
}
</script>

<style lang="css" scoped>
.boxicon .content {
  text-align: justify !important;
}
.col-border-shaddow {
  -webkit-box-shadow: 0 2px 3px rgba(87, 43, 43, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  background-color: #fff;
  text-align: center;
}
.col-rotate {
  transform: rotate(-90deg);
  height: 48px;
  margin-top: 48px;
  margin-left: -56px;
  margin-right: -56px;
  text-align: center;
  border-radius: 15%;
}
.col-content {
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  margin: auto;
}
.col-content-1 {
  color: #d14d65;
}
.col-content-1:hover {
  background-color: #d14d65;
  opacity: 0.8;
  color: #fff;
}
.col-content-2 {
  color: #8a4869;
}
.col-content-2:hover {
  background-color: #8a4869;
  opacity: 0.8;
  color: #fff;
}
.col-content-3 {
  color: #5f548d;
}
.col-content-3:hover {
  background-color: #5f548d;
  opacity: 0.8;
  color: #fff;
}
.col-content-4 {
  color: #3b589f;
}
.col-content-4:hover {
  background-color: #3b589f;
  opacity: 0.8;
  color: #fff;
}
.col-content-5 {
  color: #0d7eb6;
}
.col-content-5:hover {
  background-color: #0d7eb6;
  opacity: 0.8;
  color: #fff;
}
</style>
